import { AfterViewInit, Directive, HostBinding, Input, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenu } from "@angular/material/menu";
import { Subscription } from "rxjs";

@Directive({
    selector: '[disableIfAllMenuItemsDisabled]'
})
export class DisableMenuIfDisabledChildrenDirective implements AfterViewInit, OnDestroy {
    @Input('disableIfAllMenuItemsDisabled')
    menu: MatMenu;

    private subscription = new Subscription();

    constructor(private button: MatButton){}

    ngAfterViewInit(): void {
    this.updateButtonState();

    this.subscription.add(
      this.menu.items.changes.subscribe(() => {
        this.updateButtonState();
      })
    );
  }

  private updateButtonState(): void {
    const items = this.menu?.items?.toArray() || [];

    this.button.disabled =
      items.length === 0 ||
      items.every(item => item.disabled);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}